import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { FileUpIcon, FolderPlusIcon, FolderUpIcon } from 'lucide-react';

import { ButtonGroup, Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export interface FsActionsButtonsProps extends ComponentProps<'div'> {
  onCreateDir: () => void;
  disabled: boolean;
  onUploadFilesOpen: () => void;
  onUploadDirOpen: () => void;
}

export default function FsActionButtons(fsActionsButtonsProps: FsActionsButtonsProps) {
  const { onCreateDir, disabled, onUploadDirOpen, onUploadFilesOpen, className, ...props } = fsActionsButtonsProps;

  return (
    <div className={cn('flex gap-2 md:gap-3', className)} {...props}>
      <ButtonGroup>
        {/* Create Folder */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" onClick={onCreateDir} disabled={disabled}>
              <FolderPlusIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Nowy folder</TooltipContent>
        </Tooltip>

        {/* Upload File */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" disabled={disabled} onClick={onUploadFilesOpen}>
              <FileUpIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Prześlij plik</TooltipContent>
        </Tooltip>

        {/* Upload Folder */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" disabled={disabled} onClick={onUploadDirOpen}>
              <FolderUpIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Prześlij folder</TooltipContent>
        </Tooltip>
      </ButtonGroup>
    </div>
  );
}
